module.exports = __webpack_public_path__ + "media/hyper/images/small/small-3-c89ec1a069b2604d34f3b944b57a1d89.jpg";